<template>
     <div>
        <modal 
        name="scheduleMeetingModal" 
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="500px"
        height="auto"> 
        <div class="v-modal">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">Schedule Video Verification Meeting</h2>
                <span @click="hideMe()">
                <em class="material-icons">close</em>
                </span>
            </div>
            <form @submit.prevent data-vv-scope="meetingForm" @click="meetingErr= ''" >
                <div class="form-container" @click="meetingErr=''">
                    <div class="vx-row">
                        <datepickerField :display="true" :dateEnableFrom="new Date()"   :formscope="'meetingForm'" :fieldName="'scheduleDate'" :cid="'scheduleDate'" :validationRequired="true" v-model="meetingData.scheduleDate" label="Date" />
                        <selectField :display="false" :required="true" :optionslist="timeList" v-model="meetingData.scheduleTime" :formscope="'meetingForm'" :fieldName="'scheduleTime'" label="Time" placeHolder="Time" />

                        <selectField :display="false" :wrapclass="'w-full'" :required="true" :optionslist="timeZoneList" v-model="meetingData.scheduleTimezone" :formscope="'meetingForm'" :fieldName="'scheduleTimezone'" label="Timezone" placeHolder="Timezone" />
                    </div>
                    <div class="vx-col  w-full ">
                      <div class="form_group">
                          <quillTextEditor :wrapclass="'form_group'" :fieldName="'scheduleComment'" :required="true"  :cid="'scheduleComment'"
                          :customValidNotRequire="false" v-model="meetingData.scheduleComment" :canSpellCheck="true" label="Comments" 
                          placeHolder="Comments" :vvas="'Comments'" :formscope="'meetingForm'"
                          />
                      </div>
                    </div>
                    <div class="text-danger text-sm formerrors custom_margin" v-show="meetingErr">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                        icon="IP-information-button" active="true">{{ meetingErr }}</vs-alert>
                    </div>                    
                </div>
                <div class="popup-footer relative">
                    <span class="loader" v-if="loadingRequest" ><img src="@/assets/images/main/loader.gif" /></span>
                    <vs-button color="dark" @click="hideMe()" class="cancel" type="filled">Cancel</vs-button>
                    <vs-button color="success" @click="scheduleMeeting()" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </div>
        </modal>
     </div>
</template>
<script>
import quillTextEditor from"@/views/forms/fields/quillTextEditor.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components:{
        selectField,
        datepickerField,
        quillTextEditor
    },
    data: () => ({
        meetingData:{
            scheduleDate:null,
            scheduleTime:null,
            scheduleTimezone:null,
            scheduleComment:''
        },
        timeZoneList:[],
        timeList:[],
        loadingRequest:false,
        meetingErr:''
        
    }),
    props:{
        petitionDetails:null,
        callFromEdit:{
            type:Boolean,
            default:false
        },
        i9Id:'',
    },
    methods:{
        getTimeZones(){
            let postData = {
                page: 1,
                perpage: 1000,
                category: "timezone"
            };
            this.$store.dispatch("getMasterData", postData).then((res) => {
                _.forEach(res['list'], (item) => {
                    item['tempName'] = item['name']
                    item.name = item['name'] + ' (' + item.id + ')';
                    this.timeZoneList.push(item);
                })
                if(this.callFromEdit){
                    this.updateData()
                }
            })
        },
        hideMe(){
            this.$emit('hideMeeting');
            this.$modal.hide('scheduleMeetingModal');
        },
        scheduleMeeting(){
            this.$validator.validateAll('meetingForm').then((result)=>{
                if(result){
                    let payLoad={}
                    let path;
                    if(this.callFromEdit){
                        path='/video-call/reschedule'
                        payLoad['videoCallId'] = this.checkProperty(this.petitionDetails, 'videoCallDetails', '_id'),
                        payLoad['scheduledOn'] = this.checkProperty(this.meetingData, 'scheduleDate'),
                        payLoad['scheduledTime'] = this.checkProperty(this.meetingData, 'scheduleTime', 'name'),
                        payLoad['scheduledTimezone'] = this.checkProperty(this.meetingData, 'scheduleTimezone', 'tempName'),
                        payLoad['comment'] = this.checkProperty(this.meetingData, 'scheduleComment')
                    }else{
                        path='/video-call/schedule'
                        payLoad['entityId'] = this.i9Id,
                        payLoad['entityType'] = 'i9',
                        payLoad['scheduledOn'] = this.checkProperty(this.meetingData, 'scheduleDate'),
                        payLoad['scheduledTime'] = this.checkProperty(this.meetingData, 'scheduleTime', 'name'),
                        payLoad['scheduledTimezone'] = this.checkProperty(this.meetingData, 'scheduleTimezone', 'tempName'),
                        payLoad['comment'] = this.checkProperty(this.meetingData, 'scheduleComment')
                    }
                    // let payLoad ={
                    //     scheduleType:this.callFromEdit?'reschedule':'schedule',
                    //     scheduleDate:this.checkProperty(this.meetingData, 'scheduleDate'),
                    //     scheduleTime:this.checkProperty(this.meetingData, 'scheduleTime', 'name'),
                    //     scheduleTimezone:this.checkProperty(this.meetingData, 'scheduleTimezone', 'tempName'),
                    //     scheduleComment:this.checkProperty(this.meetingData, 'scheduleComment')
                    // }
                    // payLoad['entityId'] = this.i9Id;
                    // payLoad['entityType'] = "i9"
                    // let path = '/i9/schedule-meeting'; 
                    this.loadingRequest = true;
                    this.$store.dispatch('commonAction', {data:payLoad, 'path':path}).then((res)=>{
                        this.loadingRequest = false;
                        this.showToster({message:res.message ,isError:false});
                        this.hideMe();
                    }).catch((err)=>{
                        this.loadingRequest = false;
                        this.meetingErr = err;
                    })
                }
            })
        },
        generateScheduleTimes() {
            let scheduleTimes = [];
            let id = 1;
            for (let hour = 0; hour < 24; hour++) {
                for (let minute = 0; minute < 60; minute += 15) {
                    let formattedHour = hour.toString().padStart(2, '0');
                    let formattedMinute = minute.toString().padStart(2, '0');
                    scheduleTimes.push({
                        id: id,
                        name: `${formattedHour}:${formattedMinute}`
                    });
                    id++;
                }
            }
            this.timeList = scheduleTimes;
        },
        updateData(){
            if(this.checkProperty(this.petitionDetails,'videoCallDetails', 'comment')){
                this.meetingData['scheduleComment'] = this.checkProperty(this.petitionDetails,'videoCallDetails','comment');
            }
            if(this.checkProperty(this.petitionDetails,'videoCallDetails','scheduledOn')){
                this.meetingData['scheduleDate'] = this.checkProperty(this.petitionDetails, 'videoCallDetails','scheduledOn');
            }
            if(this.checkProperty(this.petitionDetails,'videoCallDetails','scheduledTime')){
                if(this.checkProperty(this.timeList, 'length')>0){
                    let findObj = _.find(this.timeList, {'name':this.petitionDetails['videoCallDetails']['scheduledTime']});
                    if(findObj){
                        this.meetingData['scheduleTime'] = findObj;
                    }
                }
            }
            if(this.checkProperty(this.petitionDetails,'videoCallDetails', 'scheduledTimezone')){
                if(this.checkProperty(this.timeZoneList, 'length')>0){
                    let findObj = _.find(this.timeZoneList, {'tempName':this.petitionDetails['videoCallDetails']['scheduledTimezone']});
                    if(findObj){
                        this.meetingData['scheduleTimezone'] = findObj;
                    }
                }
                this.meetingData = _.cloneDeep(this.meetingData)
            }
        }

    },
    mounted(){
        this.getTimeZones();
        this.generateScheduleTimes();
        this.$modal.show('scheduleMeetingModal');
        

    }
}
</script>